import React from 'react';
import {
  Checkbox,
  Column,
  Flex,
  IColumnProps,
} from '@grubhubprod/gh-cookbook-react';
import { useDataTableSelectionContext } from 'src/components/DataTable/components/DataTableSelectionProvider/hooks/useDataTableSelectionContext';

export type DataTableSelectionColumnHeaderProps = Pick<
  IColumnProps,
  'phone' | 'tablet' | 'desktop'
>;

export const DataTableSelectionColumnHeader: React.FC<DataTableSelectionColumnHeaderProps> =
  ({ phone = 1, tablet, desktop }) => {
    const { isAllSelected, isPartiallySelected, toggleAll, isLoading } =
      useDataTableSelectionContext();

    const handleChange = (): void => {
      if (!isLoading) {
        toggleAll();
      }
    };

    return (
      <Column phone={phone} tablet={tablet} desktop={desktop} gutter={12}>
        <Flex
          className="cancelMarginCheckboxLabel"
          alignItems="center"
          justifyContent="flex-start"
          width="100%"
          height="100%"
        >
          <Checkbox
            checked={isAllSelected}
            indeterminate={isPartiallySelected}
            onChange={handleChange}
            disabled={isLoading}
          />
        </Flex>
      </Column>
    );
  };
